export const CASE_STUDY_SLUG = "case-studies"
export const CASE_STUDY_CATEGORY = "Case Study"
export const WHITE_PAPER_SLUG = "white-papers"
export const WHITE_PAPER_CATEGORY = "White Paper"
export const NEWS_SLUG = "news"
export const NEWS_CATEGORY = "News"
